var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResidentialEx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.429688 4.375C0.429688 3.87772 0.627232 3.40081 0.978862 3.04917C1.33049 2.69754 1.80741 2.5 2.30469 2.5H18.5547C19.052 2.5 19.5289 2.69754 19.8805 3.04917C20.2321 3.40081 20.4297 3.87772 20.4297 4.375V15.625C20.4297 16.1223 20.2321 16.5992 19.8805 16.9508C19.5289 17.3025 19.052 17.5 18.5547 17.5H2.30469C1.80741 17.5 1.33049 17.3025 0.978862 16.9508C0.627232 16.5992 0.429688 16.1223 0.429688 15.625L0.429688 4.375ZM2.30469 3.75C2.13893 3.75 1.97996 3.81585 1.86275 3.93306C1.74554 4.05027 1.67969 4.20924 1.67969 4.375V15.625C1.67969 15.7908 1.74554 15.9497 1.86275 16.0669C1.97996 16.1842 2.13893 16.25 2.30469 16.25H18.5547C18.7204 16.25 18.8794 16.1842 18.9966 16.0669C19.1138 15.9497 19.1797 15.7908 19.1797 15.625V4.375C19.1797 4.20924 19.1138 4.05027 18.9966 3.93306C18.8794 3.81585 18.7204 3.75 18.5547 3.75H2.30469Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4297 10.625C10.4297 10.4592 10.4955 10.3003 10.6127 10.1831C10.73 10.0658 10.8889 10 11.0547 10H17.3047C17.4704 10 17.6294 10.0658 17.7466 10.1831C17.8638 10.3003 17.9297 10.4592 17.9297 10.625V14.375C17.9297 14.5408 17.8638 14.6997 17.7466 14.8169C17.6294 14.9342 17.4704 15 17.3047 15H11.0547C10.8889 15 10.73 14.9342 10.6127 14.8169C10.4955 14.6997 10.4297 14.5408 10.4297 14.375V10.625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidentialEx);
export default __webpack_public_path__ + "static/media/residentialEx.a9eca7181fd92fa7cc80a8986538d5db.svg";
export { ForwardRef as ReactComponent };